<template>
  <Navbar v-if="showComponent" />
  <div class="page-content">
    <Sidebar v-if="$route.name === 'ProgressCourse'" />
    <div class="content-wrapper">
      <div class="content-inner">
        <div
          class="content"
          :class="{
            'd-flex justify-content-center align-items-center': addClass,
          }"
        >
          <slot />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Navbar from '@/components/commons/Navbar.vue'
import Sidebar from '@/components/commons/Sidebar.vue'

export default {
  name: 'Layout',

  components: {
    Navbar,
    Sidebar,
  },

  data() {
    return {
      routesName: [
        'Index',
        'Register',
        'Auth',
        'PasswordRecovery',
        'NewPassword',
        'CertificateAuth',
        'Unauthorized',
        'NotFound',
      ],
    }
  },

  computed: {
    addClass() {
      return (
        this.routesName.includes(this.$route.name) &&
        this.$route.name !== 'Register'
      )
    },

    showComponent() {
      return !this.routesName.includes(this.$route.name)
    },
  },
}
</script>
